import * as R from './reducers';
import { defaultGlobalState } from './defaultGlobalState';

const combineReducers = reducers => {
  const keys = Object.keys(reducers);
  return (state, action) => {
    const newState = {};

    keys.forEach(key => {
      newState[key] = reducers[key](state[key], action);
    });

    return action.type === 'LOGOUT' ? defaultGlobalState : newState;
  };
};

export const globalStateReducer = combineReducers(R);
